<template>
  <div class="instruction">
    <img v-if="item.params.image_id" :src="imageUrl(item.params.image_id)" :alt="item.params.image_id">
  </div>
</template>

<script>
  import { imageUrl } from '@/services/assets-api/assetsClient';

  // No response needed type of question
  export default {
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {
      imageUrl,
    },
  };
</script>
